import url from '../config/url';

import axios from 'axios';
var count = 0;
// var tableData = {};
function isEmpty(obj) {
    for(var key in obj) {
        if(obj.hasOwnProperty(key))
            return false;
    }
    return true;
}
function callMe(bookno, callingFrom,api){
    
    return axios.get(url + api)
        .then(response => {
            var tableData = {};
            if(response.data.status){
                tableData = response.data.successObject.book;
                tableData.success = response.data.status;
                
                switch(callingFrom){
                    
                    case "sendout":
                        // console.log('sendout case executed inside sort api')
                        tableData.message = '';
                        // tableData.status = response.data.status;
                        break;
                    default: 
                        if(!isEmpty(response.data.successObject.ibt))
                        {
                            tableData.apiresponse = response.data.successObject;
                            
                            tableData.ibtId = response.data.successObject.ibt.ibtId;
                            
                            tableData.requestedBranchId = 
                            response.data.successObject.ibt.requestedBranch.id + '-'
                                +
                            response.data.successObject.ibt.requestedBranch.branchName; 
                            
                            tableData.origLocationBranchId = 
                            response.data.successObject.book.origLocation
                        }
                        break;
                }
            }
            else{
                tableData.errorDesc = response.data.errorDescription;
            }
            console.log('call api tableData is ');
            console.log(tableData);
            return tableData;
        }).catch(err => {
            console.log(err);
        });    
}


export default callMe;


// WEBPACK FOOTER //
// ./src/Components/callApi.js